module.exports = __webpack_public_path__ + "static/media/travel-bg-shape.ac0946be.svg";